
const localStorageAdapter = {
  getItem: function(currentRoute) {
    return localStorage.getItem(currentRoute);
  },
  setItem: function(key, value) {
    localStorage.setItem(key, value);
  },
  removeItem: function(key) {
    localStorage.removeItem(key);
  }
};
// 使用localStorage适配器获取数据
const myData = localStorageAdapter.getItem('currentRoute');

// // 使用localStorage适配器设置数据
// localStorageAdapter.setItem('myKey', 'myValue');

// // 使用localStorage适配器删除数据
// localStorageAdapter.removeItem('myKey');

export default myData